import React from "react";
import initiateddot from "../../../../assets/images/initiatedDot.png";
import activedot from "../../../../assets/images/activeDot.png";
import pendingdot from "../../../../assets/images/pendingDot.png";
import closeddot from "../../../../assets/images/closedDot.png";
import mandate from "../../../../assets/images/mandate.png";
import share from "../../../../assets/images/share.png";
import amount from "../../../../assets/images/amount.png";
import document from "../../../../assets/images/document.png";
import { formatToIndianRupees } from "../../../../utils/formatToIndianRupees";
import {
  Table,
} from "reactstrap"
export default function LoanDetails(props) {
  const { emidetails, emiTable, applicationDetails } = props;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        gap: "50px",
      }}
    >
      <div
        style={{
          height: "300px",
          borderStyle: "solid",
          borderWidth: "1px",
          borderColor: "#DBDBDB",
          width: "100%",
          padding: "10px",
          borderRadius: "10px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            height: "30px",
            marginLeft: "20px",
          }}
        >
          <img style={{ height: "26px", width: "28px" }} src={mandate} alt="" />
          <p
            style={{
              fontFamily: "Inter-Medium",
              fontSize: "14px",
              fontWeight: "500",
              marginTop: "13px",
            }}
          >
            Loan Details
          </p>
          <p
            style={{
              fontFamily: "Inter-Medium",
              fontSize: "14px",
              fontWeight: "500",
              marginTop: "13px",
              paddingLeft: "70px",
              marginLeft: "90px",
            }}
          >
            Loan Id : {emidetails ? emidetails[0]?.loanId : "N/A"}
          </p>
        </div>
        <div
          style={{
            borderTop: "0.75px solid #DBDBDB",
            margin: "10px 0",
          }}
        ></div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div>
              <p
                style={{
                  fontWeight: "400",
                  color: "#667085",
                  fontFamily: "Inter-Medium",
                  fontSize: "18px",
                  lineHeight: "10px",
                  marginTop: "13px",
                }}
              >
                Amount Disbursed
              </p>
              <p
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "16px",
                }}
              >
                {formatToIndianRupees(
                  applicationDetails?.profile?.disbursementData?.disbursedAmount
                ) || "-------"}
              </p>
            </div>
            <div style={{ marginRight: "20px", marginTop: "40px" }}>
              <p
                style={{
                  fontWeight: "400",
                  color: "#667085",
                  fontFamily: "Inter-Medium",
                  fontSize: "18px",
                  lineHeight: "10px",
                }}
              >
                EMI
              </p>
              <p
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "16px",
                }}
              >
                {formatToIndianRupees(emidetails?.[0]?.emiAmount) || "-------"}
              </p>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              marginRight: "50px",
            }}
          >
            <div>
              <p
                style={{
                  fontWeight: "400",
                  color: "#667085",
                  fontFamily: "Inter-Medium",
                  fontSize: "18px",
                  lineHeight: "10px",
                  marginTop: "13px",
                }}
              >
                Loan Amount
              </p>
              <p
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "16px",
                }}
              >
                {formatToIndianRupees(
                  applicationDetails?.profile?.userDetails?.loanAmount
                ) || "-------"}
              </p>
            </div>
            <div style={{ marginRight: "20px" }}>
              <p
                style={{
                  fontWeight: "400",
                  color: "#667085",
                  fontFamily: "Inter-Medium",
                  fontSize: "18px",
                  lineHeight: "10px",
                }}
              >
                No Dues
              </p>
              <p>
                {" "}
                <a
                  style={{
                    fontFamily: "Inter-Medium",
                    fontSize: "16px",
                  }}
                  href="#"
                >
                  Download
                </a>{" "}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          height: "300px",
          borderStyle: "solid",
          borderWidth: "1px",
          borderColor: "#DBDBDB",
          overflow: "auto",
          width: "100%",
          padding: "10px",
          borderRadius: "10px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            height: "30px",
            marginLeft: "20px",
          }}
        >
          <img style={{ height: "26px", width: "28px" }} src={mandate} alt="" />
          <p
            style={{
              fontFamily: "Inter-Medium",
              fontSize: "14px",
              fontWeight: "500",
              marginTop: "13px",
            }}
          >
            EMI History
          </p>
        </div>
        <div
          style={{
            borderTop: "0.75px solid #DBDBDB",
            margin: "10px 0",
          }}
        ></div>
        <div style={{ width: "100%" }}>
          <Table style={{ border: "none" }}>
            <thead>
              <th
                style={{
                  color: "#D32028",
                  fontWeight: "600",
                  textAlign: "center",
                  fontFamily: "Inter-Medium",
                  fontSize: "14px",
                }}
              >
                Due Date
              </th>
              <th
                style={{
                  color: "#D32028",
                  fontWeight: "600",
                  textAlign: "center",
                  fontFamily: "Inter-Medium",
                  fontSize: "14px",
                }}
              >
                Emi
              </th>
              <th
                style={{
                  color: "#D32028",
                  fontWeight: "600",
                  textAlign: "center",
                  fontFamily: "Inter-Medium",
                  fontSize: "14px",
                }}
              >
                Status
              </th>
              <th
                style={{
                  color: "#D32028",
                  fontWeight: "600",
                  textAlign: "center",
                  fontFamily: "Inter-Medium",
                  fontSize: "14px",
                }}
              >
                Action
              </th>
            </thead>
            <tbody style={{ maxHeight: "100%" }}>
              {emiTable && emiTable.length > 0 ? (
                emiTable.map((item, idx) => (
                  <tr
                    style={{
                      lineHeight: "15px",
                      borderBottom: "1px solid #DBDBDB",
                    }}
                    key={idx}
                  >
                    <td
                      style={{
                        textAlign: "center",
                        fontFamily: "Inter-Medium",
                        fontWeight: "300",
                        fontSize: "14px",
                      }}
                    >
                      {item.dueDate}
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        fontFamily: "Inter-Medium",
                        fontSize: "14px",
                        fontWeight: "300",
                      }}
                    >
                      {item.emiAmount}
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        fontFamily: "Inter-Medium",
                        fontSize: "14px",
                        fontWeight: "300",
                      }}
                    >
                      {item.status ? (
                        item.status === 1 ? (
                          <span
                            style={{
                              backgroundColor: "#EFE4FF",
                              color: "#6E24E7",
                              borderRadius: "8px",
                              padding: "3px",
                              fontFamily: "Outfit",
                              fontSize: "13px",
                            }}
                          >
                            <img src={initiateddot} alt="" />
                            UnPaid
                          </span>
                        ) : item.status === 3 ? (
                          <span
                            style={{
                              backgroundColor: "#FFF6E8",
                              color: "#F8A31F",
                              borderRadius: "8px",
                              padding: "3px",
                              fontFamily: "Outfit",
                              fontSize: "13px",
                            }}
                          >
                            <img src={pendingdot} alt="" />
                            PartlyPaid
                          </span>
                        ) : item.status === 2 ? (
                          <span
                            style={{
                              backgroundColor: "#ECFDF3",
                              color: "#12B76A",
                              borderRadius: "8px",
                              padding: "3px",
                              fontFamily: "Outfit",
                              fontSize: "13px",
                            }}
                          >
                            <img src={activedot} alt="" />
                            Paid
                          </span>
                        ) : item.status === 4 ? (
                          <span
                            style={{
                              backgroundColor: "#8ab7ff",
                              color: "black",
                              borderRadius: "8px",
                              padding: "3px",
                              fontFamily: "Outfit",
                              fontSize: "13px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            OvdPd.
                          </span>
                        ) : item.status === 5 ? (
                          <span
                            style={{
                              backgroundColor: "#FEEAEB",
                              color: "#D22129",
                              borderRadius: "8px",
                              padding: "3px",
                              fontFamily: "Outfit",
                              fontSize: "13px",
                            }}
                          >
                            <img src={closeddot} alt="" />
                            Ovd
                          </span>
                        ) : item.status === 6 ? (
                          <span
                            style={{
                              backgroundColor: "#FFF6E8",
                              color: "#F8A31F",
                              borderRadius: "8px",
                              padding: "3px",
                              fontFamily: "Outfit",
                              fontSize: "13px",
                            }}
                          >
                            <img src={pendingdot} alt="" />
                            Paused
                          </span>
                        ) : item.status === 7 ? (
                          <span
                            style={{
                              backgroundColor: "#EDC7E2",
                              color: "black",
                              borderRadius: "8px",
                              padding: "3px",
                              fontFamily: "Outfit",
                              fontSize: "13px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <img src={pendingdot} alt="" />
                            Mand.In Prog
                          </span>
                        ) : item.status === 9 ? (
                          <span
                            style={{
                              backgroundColor: "#ECFDF3",
                              color: "#12B76A",
                              borderRadius: "8px",
                              padding: "3px",
                              fontFamily: "Outfit",
                              fontSize: "13px",
                            }}
                          >
                            <img src={activedot} alt="" />
                            PreCls
                          </span>
                        ) : item.status === 10 ? (
                          <span
                            style={{
                              backgroundColor: "#424242",
                              color: "#E0FFFF",
                              borderRadius: "8px",
                              padding: "3px",
                              fontFamily: "Outfit",
                              fontSize: "13px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Refund
                          </span>
                        ) : item.status === 12 ? (
                          <span
                            style={{
                              backgroundColor: "#ebeebe",
                              color: "black",
                              borderRadius: "8px",
                              padding: "3px",
                              fontFamily: "Outfit",
                              fontSize: "13px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <img src={pendingdot} alt="" />
                            WrtOff
                          </span>
                        ) : item.status === 11 ? (
                          <span
                            style={{
                              backgroundColor: "#c2f2f3",
                              color: "black",
                              borderRadius: "8px",
                              padding: "3px",
                              fontFamily: "Outfit",
                              fontSize: "13px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <img src={pendingdot} alt="" />
                            Settled
                          </span>
                        ) : (
                          item.status
                        )
                      ) : (
                        "-"
                      )}{" "}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <img
                        style={{
                          marginRight: "5px",
                          cursor: "pointer",
                        }}
                        src={document}
                        alt="document"
                      />
                      <img
                        style={{
                          marginRight: "5px",
                          cursor: "pointer",
                        }}
                        src={share}
                        alt="share"
                      />
                      <img
                        style={{
                          height: "22px",
                          width: "24px",
                          cursor: "pointer",
                        }}
                        src={amount}
                        alt="amount"
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="4"
                    style={{
                      textAlign: "center",
                      fontFamily: "Inter-Medium",
                      fontSize: "14px",
                      fontWeight: "300",
                      borderBottom: "1px solid #DBDBDB",
                    }}
                  >
                    -------
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
}
